module.exports = __webpack_public_path__ + "af0868ebd76742d80cbc3e17a79dc65b.jpg";